import React, { useState, useEffect } from "react";
import { toggleMenu } from "../../../utils/helpers";
import PageTitle from "../../../components/PageTitle";
import { ThreeDots } from "react-loader-spinner";
import DisplayProjectDetails from "../../../components/ProjectManagement/DisplayProjectDetails";
import { getApi } from "../../../utils/api";
import Cookies from "js-cookie";
import { API_GET_ALL_PROJECTS_PROJECTID_AND_PROJECTNAME } from "../../../config/Endpoints";
import { MdKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";

const ShadowResources = ({ title, description }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [filteredItems, setFilteredItems] = useState(projectList);
  const [openProjectId, setOpenProjectId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredItems(
      projectList.filter((p) => p.projectName.toLowerCase().includes(value))
    );
  };

  useEffect(() => {
    const fetchProjects = async () => {
      setIsLoading(true);
      try {
        const res = await getApi(
          API_GET_ALL_PROJECTS_PROJECTID_AND_PROJECTNAME,
          accessToken
        );
        const data = res.data?.data;
        setProjectList(data);
        setFilteredItems(data);
      } catch (err) {
        console.error("Error fetching projects", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const toggleProject = (id) => {
    setOpenProjectId(openProjectId === id ? null : id);
  };

  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Projects : <span>{filteredItems.length}</span>
        </div>
      </div>

      <div className="filters">
        <div className="search m-0">
          <input
            type="text"
            placeholder="Search By Project Name"
            value={searchTerm}
            onChange={handleSearch}
          />
          <img src="/assets/images/search-ico.svg" width="14" alt="Search" />
        </div>
      </div>

      <div className="accordion">
        {isLoading ? (
          <div className="centered-loader">
            <ThreeDots
              height="100"
              width="100"
              radius="9"
              color="blue"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        ) : filteredItems.length === 0 ? (
          <p className="fs-4 m-5 text-secondary text-center">
            No Projects Assigned
          </p>
        ) : (
          filteredItems.map((project) => (
            <div
              className={`accordion-item project-accordion-item ${
                openProjectId === project.projectId ? "open" : ""
              }`}
              key={project.projectId}
            >
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${
                    openProjectId === project.projectId ? "" : "collapsed"
                  }`}
                  type="button"
                  onClick={() => toggleProject(project.projectId)}
                >
                  <span>{project.projectName}</span>

                  <span
                    className={`project-status-badge ${
                      project.status === 1
                        ? " badge-complete"
                        : project.status === 2
                        ? "badge-onhold"
                        : "badge-active"
                    }`}
                  >
                    {project.status === 1
                      ? "Completed"
                      : project.status === 2
                      ? "On Hold"
                      : "Active"}
                  </span>
                  {openProjectId === project.projectId ? (
                    <MdOutlineKeyboardArrowUp className="dropdown-icon" />
                  ) : (
                    <MdKeyboardArrowDown className="dropdown-icon" />
                  )}
                </button>
              </h2>

              {openProjectId === project.projectId && (
                <div className="accordion-collapse show">
                  <div className="accordion-body">
                    <DisplayProjectDetails
                      projectId={project.projectId}
                      isOpen={openProjectId === project.projectId}
                    />
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ShadowResources;
